import { SerializableObject } from '../../core';


/**
 * Interface for `MobizSettings.value`.
 */
export abstract class MobizSettingsValue extends SerializableObject {
}
